import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { IWorktask } from '../worktask.service';
import { objectValidator, ObjectValidators, ValidatorMap } from './objectValidator';

@Injectable({ providedIn: 'root' })
export class MesWorkTaskValidationService {
	constructor(private translator: TranslateService) {}

	validators(ValidateId: boolean = true): ValidatorMap<IWorktask> {
		const validator: ValidatorMap<IWorktask> = {
			id: [ObjectValidators.required],
			alias: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.worktasks.dialog.alias.error.pattern')],
			name: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Description, 'mes.administration.worktasks.dialog.name.error.pattern')],
			tags: [ObjectValidators.required],
			isActive: [ObjectValidators.required],
		};

		if (!ValidateId) {
			delete validator.id;
		}

		return validator;
	}

	validateWorkTask(task: IWorktask, ValidateId: boolean = true): Record<string, ValidationErrors> {
		return objectValidator.validateObject(task, this.validators(ValidateId), this.translator);
	}
}
